export default __webpack_public_path__ + "static/media/manageit.23ad578c.png";